(function() {
  'use strict';
  
  // Create a global cart state manager
  window.CartStateManager = {
    // Initialize the cart state manager
    init: function() {
      console.log('Initializing CartStateManager...');
      this.setupEventListeners();
      this.refreshCartState();
    },
    
    // Setup all event listeners
    setupEventListeners: function() {
      // Handle browser back button (pageshow event)
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          console.log('Page restored from cache - refreshing cart state');
          this.refreshCartState();
        }
      });
      
      // Handle visibility change (another backup)
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          setTimeout(() => this.refreshCartState(), 100);
        }
      });
      
      // Handle window focus (additional backup)
      window.addEventListener('focus', () => {
        setTimeout(() => this.refreshCartState(), 100);
      });
      
      // Listen for cart updates from other tabs
      this.setupCrossTabCommunication();
    },
    
    // Setup cross-tab communication
    setupCrossTabCommunication: function() {
      let broadcastChannel = null;
      
      try {
        broadcastChannel = new BroadcastChannel('cart_updates');
      } catch (e) {
        console.log('BroadcastChannel not supported, using localStorage events');
      }
      
      // Function to broadcast cart updates
      this.broadcastCartUpdate = function(action, data) {
        const message = {
          action: action,
          data: data,
          timestamp: Date.now()
        };
        
        console.log('Broadcasting cart update:', message);
        
        // Try BroadcastChannel first
        if (broadcastChannel) {
          try {
            broadcastChannel.postMessage(message);
          } catch (e) {
            console.error('Broadcast failed:', e);
          }
        }
        
        // Fallback to localStorage
        try {
          localStorage.setItem('cart_update_broadcast', JSON.stringify(message));
          setTimeout(() => localStorage.removeItem('cart_update_broadcast'), 100);
        } catch (e) {
          console.error('localStorage broadcast failed:', e);
        }
      };
      
      // Listen for cart updates from other pages
      if (broadcastChannel) {
        broadcastChannel.onmessage = (event) => {
          console.log('Received cart update from another page:', event.data);
          this.refreshCartState();
        };
      }
      
      // Fallback: Listen for localStorage changes
      window.addEventListener('storage', (e) => {
        if (e.key === 'cart_update_broadcast' && e.newValue) {
          try {
            const message = JSON.parse(e.newValue);
            console.log('Received cart update via localStorage:', message);
            this.refreshCartState();
          } catch (err) {
            console.error('Error parsing cart update:', err);
          }
        }
      });
    },
    
    // Refresh cart state across all pages
    refreshCartState: function() {
      console.log('Refreshing cart state...');
      
      // Fetch the latest cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Cart data received:', cart);
          
          // Update cart count in header
          this.updateHeaderCartCount(cart);
          
          // Update product page if it exists
          this.updateProductPage(cart);
          
          // Update collection page if it exists
          this.updateCollectionPage(cart);
          
          // Dispatch custom event for other scripts
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { itemCount: cart.item_count, cart: cart }
          }));
        })
        .catch(e => console.error('Error refreshing cart state:', e));
    },
    
    // Update cart count in header
    updateHeaderCartCount: function(cart) {
      const selectors = [
        '.header-cart-link span',
        '.cart-count',
        '.cart-link span',
        '[data-cart-count]',
        '#cart-count',
        '.header__cart-count'
      ];
      
      selectors.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
          element.textContent = cart.item_count;
          if (element.hasAttribute('data-cart-count')) {
            element.setAttribute('data-cart-count', cart.item_count);
          }
        }
      });
    },
    
    // Update product page
    updateProductPage: function(cart) {
      const mainForm = document.querySelector('.product-form-custom');
      if (!mainForm) return;
      
      const hiddenSelect = mainForm.querySelector('.hidden-variant-select');
      const currentVariantId = hiddenSelect ? hiddenSelect.value : null;
      
      if (!currentVariantId) return;
      
      const cartItem = cart.items.find(item => item.variant_id == currentVariantId);
      const quantityWrapper = mainForm.querySelector('.quantity-selector-wrapper');
      const quantityInput = mainForm.querySelector('.quantity-input');
      const addToCartBtn = mainForm.querySelector('.add-to-cart-btn');
      
      console.log(`Updating product page for variant ${currentVariantId}:`, cartItem);
      
      if (cartItem && cartItem.quantity > 0) {
        // Item is in cart - show quantity selector and hide add to cart button
        if (quantityWrapper) {
          quantityWrapper.style.display = 'flex';
          console.log('Showing quantity selector');
        }
        if (quantityInput) {
          quantityInput.value = cartItem.quantity;
          console.log('Setting quantity to:', cartItem.quantity);
        }
        if (addToCartBtn) {
          addToCartBtn.style.display = 'none';
          console.log('Hiding add to cart button');
        }
      } else {
        // Item is not in cart - hide quantity selector and show add to cart button
        if (quantityWrapper) {
          quantityWrapper.style.display = 'none';
          console.log('Hiding quantity selector');
        }
        if (quantityInput) {
          quantityInput.value = 1;
        }
        if (addToCartBtn) {
          addToCartBtn.style.display = 'block';
          console.log('Showing add to cart button');
        }
      }
      
      // Update related products (Explore Our Varieties)
      document.querySelectorAll('.product-form-grid').forEach(form => {
        const variantSelect = form.querySelector('.variant-select-grid');
        const hiddenInput = form.querySelector('input[name="id"]');
        const variantId = variantSelect ? variantSelect.value : (hiddenInput ? hiddenInput.value : null);
        
        if (!variantId) return;
        
        const controls = form.querySelector('.product-form-controls-grid');
        if (!controls) return;
        
        const addToCartBtn = controls.querySelector('.add-to-cart-btn-grid');
        const quantitySelector = controls.querySelector('.quantity-selector-grid');
        const quantityDisplay = controls.querySelector('.quantity-display-grid');
        
        const cartItem = cart.items.find(item => item.variant_id == variantId);
        
        console.log(`Updating related product for variant ${variantId}:`, cartItem);
        
        if (cartItem && cartItem.quantity > 0) {
          // Item is in cart - show quantity selector and hide add to cart button
          if (addToCartBtn) {
            addToCartBtn.classList.add('hidden');
            console.log('Hiding related product add to cart button');
          }
          if (quantitySelector) {
            quantitySelector.classList.add('active');
            console.log('Showing related product quantity selector');
          }
          if (quantityDisplay) {
            quantityDisplay.textContent = cartItem.quantity;
            console.log('Setting related product quantity to:', cartItem.quantity);
          }
        } else {
          // Item is not in cart - hide quantity selector and show add to cart button
          if (addToCartBtn) {
            addToCartBtn.classList.remove('hidden');
            console.log('Showing related product add to cart button');
          }
          if (quantitySelector) {
            quantitySelector.classList.remove('active');
            console.log('Hiding related product quantity selector');
          }
          if (quantityDisplay) {
            quantityDisplay.textContent = '1';
          }
        }
      });
    },
    
    // Update collection page
    updateCollectionPage: function(cart) {
      // This is handled by updateProductPage since collection pages use the same form structure
      this.updateProductPage(cart);
    },
    
    // Format price (convert from cents to rupees)
    formatPrice: function(price) {
      return (price / 100).toFixed(2);
    }
  };
  
  // Initialize the cart state manager when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, initializing CartStateManager...');
    window.CartStateManager.init();
  });
  
  // Also initialize immediately if DOM is already loaded
  if (document.readyState === 'loading') {
    // DOM is still loading
  } else {
    // DOM is already loaded
    console.log('DOM already loaded, initializing CartStateManager...');
    window.CartStateManager.init();
  }
})();